var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import mergeClassnames from '../../../mergeClassnames/mergeClassnames';
import { OpenContext, SelectContext } from '../utils/context';
const commonClasses = 'moon-search-list-item w-full';
export const Link = (_a) => {
    var { closeOnSelect = true, disabled = false, showType = true, className, children, onClick, index } = _a, rest = __rest(_a, ["closeOnSelect", "disabled", "showType", "className", "children", "onClick", "index"]);
    const { onChangeOpen } = useContext(OpenContext);
    const { selected } = useContext(SelectContext);
    function renderLinkContent() {
        return (React.createElement("div", null, typeof children === 'function'
            ? children(selected === index)
            : children));
    }
    function clickAndClose(e) {
        if (rest.href && !disabled) {
            if (onClick) {
                onClick(e);
            }
            if (closeOnSelect) {
                onChangeOpen(false);
            }
        }
    }
    return (React.createElement("a", Object.assign({ "data-close-on-select": closeOnSelect, "aria-disabled": disabled, onClick: clickAndClose, className: mergeClassnames(commonClasses, className) }, rest), renderLinkContent()));
};
export const Button = (_a) => {
    var _b;
    var { closeOnSelect = true, showType = true, className, children, onClick, index } = _a, rest = __rest(_a, ["closeOnSelect", "showType", "className", "children", "onClick", "index"]);
    const { selected } = useContext(SelectContext);
    const { onChangeOpen } = useContext(OpenContext);
    function clickAndClose(e) {
        if (onClick) {
            onClick(e);
            if (closeOnSelect) {
                onChangeOpen(false);
            }
        }
    }
    return (React.createElement("button", Object.assign({}, rest, { "aria-disabled": (_b = rest.disabled) !== null && _b !== void 0 ? _b : false, "data-close-on-select": closeOnSelect, onClick: clickAndClose, className: mergeClassnames(commonClasses, className) }), typeof children === 'function' ? children(selected === index) : children));
};
const ResultItem = (props) => {
    const Wrapper = props.href ? Link : Button;
    return React.createElement(Wrapper, Object.assign({}, props));
};
export default ResultItem;
